import { PrimaryButton, SecondaryButton } from '@designsforhealth/dfh-react-components'
import { CircularProgress } from '@material-ui/core'
import React, { useContext } from 'react'
import { useReactToPrint } from 'react-to-print'
import styled from 'styled-components'

import { ClickWrapContext, ClickWrapModalContext } from './context'

export interface ClickWrapModalActionsProps {
  className?: string
  acceptAction: React.MouseEventHandler<HTMLButtonElement>
  acceptDisabled: boolean
  printContent: () => React.ReactInstance | null
}

const ClickWrapModalActions: React.VFC<ClickWrapModalActionsProps> = ({
  className,
  acceptAction,
  acceptDisabled,
  printContent,
}) => {
  const [, modalDispatch] = useContext(ClickWrapModalContext)
  const [{ accepted, acceptPending }] = useContext(ClickWrapContext)

  const handlePrint = useReactToPrint({
    content: printContent,
  })

  const closeClickWrap = () => {
    modalDispatch({ type: 'close' })
  }

  return (
    <div className={className}>
      <div className="modal-actions">
        <div className="modal-actions-bottom">
          {!accepted && (
            <div className="button-group">
              <PrimaryButton disabled={acceptDisabled || acceptPending} onClick={acceptAction}>
                {acceptPending ? (
                  <CircularProgress size={24} color="inherit" />
                ) : acceptDisabled ? (
                  'Review agreement to continue'
                ) : (
                  'I Agree'
                )}
              </PrimaryButton>
              <SecondaryButton onClick={closeClickWrap} text="Close" />
            </div>
          )}
          {accepted && <PrimaryButton onClick={closeClickWrap} text="Close" />}
          <SecondaryButton onClick={handlePrint} text="Print" />
        </div>
      </div>
    </div>
  )
}

const StyledClickWrapModalActions = styled(ClickWrapModalActions)(({ theme }) => ({
  '.modal-actions': {
    marginTop: '20px',
  },
  '.modal-actions-bottom': {
    display: 'flex',
    justifyContent: 'space-between',
  },
  '.button-group': {
    display: 'flex',
    'button ~ button': {
      marginLeft: '24px',
    },
  },
  [PrimaryButton]: {
    minWidth: '6em',
  },
  '.button-clickwrap': {
    width: '100%',
    display: 'block',
    backgroundColor: theme.colors.brand.blue,
    fontFamily: theme.fonts.component.button,
    fontSize: '14px',
    lineHeight: '16px',
    letterSpacing: '0.06em',
    textAlign: 'center',
    color: theme.colors.grayscale.white,
    padding: '17px 22.5px',
    border: 0,
    borderRadius: '4px',
    cursor: 'pointer',
    textTransform: 'uppercase',
    '&:disabled, &.disabled': {
      opacity: '.5',
    },
    '@media(min-width: 576px)': {
      width: 'auto',
      padding: '17px 40px',
    },
  },
}))

export default StyledClickWrapModalActions
